<template>
    <div class="u-text-center">
        <button
            :class="{
                'btn--ghost': true,
                'btn--ghost-selected': false
            }"
            @click="switchType()"
            type="button"
            dusk="switch-type-button"
            class="btn btn--small | u-full-width"
        >
            <span v-if="currentType === 'webhosting'">
                {{ trans('order.vps-pick') }}
            </span>
            <span v-if="currentType === 'vps'">
                {{ trans('order.hosting-pick') }}
            </span>
        </button>
    </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
    name: 'VpsSwitcher',

    data() {
        return {
            currentType: 'webhosting'
        };
    },

    methods: {
        // eslint-disable-next-line require-jsdoc
        switchType() {
            if (this.currentType === 'webhosting') {
                this.currentType = 'vps';
            } else {
                this.currentType = 'webhosting';
            }

            this.$emit('switchedType', this.currentType);
        }
    }
};
</script>

<style scoped></style>
